import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuleIconComponent } from './module-icon.component';

@NgModule({
  declarations: [ModuleIconComponent],
  imports: [CommonModule],
  exports: [ModuleIconComponent],
})
export class ModuleIconModule {}
